<template>
    <base-nav class="navbar-top navbar-dark"
              id="navbar-main"
              :show-toggle-button="false"
              expand>
        <img :src = "CPLogo" class="align-items-center d-md-flex ml-lg-auto" style="width:15%">
        <form class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
            <div class="form-group mb-0">
                <!--<base-input placeholder="Search"
                            class="input-group-alternative"
                            alternative=""
                            addon-right-icon="fas fa-search">
                </base-input>-->
            </div>
        </form>
        <ul class="navbar-nav align-items-center d-none d-md-flex">
            <li class="nav-item dropdown">
                <base-dropdown class="nav-link pr-0">
                    <div class="media align-items-center" slot="title">
                        <div class="media-body ml-2 d-none d-lg-block">
                            <span class="mb-0 text-sm font-weight-bold">{{userName}}<i class="fa fa-caret-down pl-2" aria-hidden="true"></i></span>
                        </div>
                    </div>


                    <template>
                        <!--<div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0">Welcome!</h6>
                        </div>-->
                        <!--<div class="dropdown-divider"></div>-->
                        <amplify-authenticator>
                            <amplify-sign-out></amplify-sign-out>
                        </amplify-authenticator>
                    </template>
                </base-dropdown>
            </li>
        </ul>
    </base-nav>
</template>
<script>
    export default {
        data() {
            return {
                activeNotifications: false,
                showMenu: false,
                searchQuery: '',
                userName: '',
                CPLogo: 'img/brand/Logo-Carepoint-Specialty-White.png'
            };
        },
        mounted() {
            this.$Amplify.Auth.currentUserInfo().then(data => {
                if (data) {
                    this.userName = data.attributes.name;
                } else {
                    this.userName = '';
                }

            });
        },
        methods: {
            toggleSidebar() {
                this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
            },
            hideSidebar() {
                this.$sidebar.displaySidebar(false);
            },
            toggleMenu() {
                this.showMenu = !this.showMenu;
            }
        }
    };
</script>
